<template>
    <component
        :is="element"
        :to="to"
        @click="$emit('click')"
        role="button"
        class="btn font-primary flex items-center rounded-lg py-2 px-2 shadow-xl"
        :class="{ 'opacity-50': disabled }"
        :disabled="disabled"
    >
        <slot></slot>
    </component>
</template>

<script>
export default {
    name: "btn",

    props: {
        to: {
            type: [String, Object]
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        element() {
            return this.to ? "router-link" : "button";
        }
    }
};
</script>

<style scoped>
.btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
